var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c(
        "div",
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-content",
                [
                  _c(
                    "collapse",
                    {
                      attrs: {
                        collapse: _vm.collapseItems,
                        icon: "keyboard_arrow_down",
                        "color-collapse": "success",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "md-collapse-pane-1" },
                        [
                          _c(
                            "md-card",
                            { staticClass: "bg-success" },
                            [
                              _c("md-card-content", [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "card-category card-category-social",
                                    staticStyle: { "text-align": "center" },
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-list-ul" }),
                                    _vm._v(" Job Description"),
                                  ]
                                ),
                                _c("h4", { staticClass: "card-title" }, [
                                  _vm._v("Job Name"),
                                ]),
                                _c("p", { staticClass: "card-description" }, [
                                  _vm._v(_vm._s(_vm.job.name)),
                                ]),
                                _c("h4", { staticClass: "card-title" }, [
                                  _vm._v("Company Name"),
                                ]),
                                _c(
                                  "h4",
                                  {
                                    staticStyle: {
                                      "margin-top": "-1px",
                                      "font-size": "15px",
                                    },
                                  },
                                  [
                                    _vm.job.clientProfile.website
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.job.clientProfile.website.startsWith(
                                                "http"
                                              )
                                                ? _vm.job.clientProfile.website
                                                : "//" +
                                                  _vm.job.clientProfile.website,
                                              target: "_blank",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.job.companyName))]
                                        )
                                      : _vm.auth
                                      ? _c(
                                          "router-link",
                                          {
                                            staticClass: "card-title",
                                            attrs: {
                                              to: {
                                                name: "view-client-profile",
                                                params: {
                                                  id: _vm.job.clientAlias,
                                                },
                                              },
                                            },
                                          },
                                          [
                                            _c("a", [
                                              _vm._v(
                                                _vm._s(_vm.job.companyName)
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _c(
                                          "p",
                                          { staticClass: "card-description" },
                                          [_vm._v(_vm._s(_vm.job.companyName))]
                                        ),
                                  ],
                                  1
                                ),
                                _c("h4", { staticClass: "card-title" }, [
                                  _vm._v("Description"),
                                ]),
                                _c("p", {
                                  staticClass: "card-description",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.micro === null
                                        ? "No Description"
                                        : _vm.micro.description
                                    ),
                                  },
                                }),
                                _c("h4", { staticClass: "card-title" }, [
                                  _vm._v("Job Category"),
                                ]),
                                _c("p", { staticClass: "card-description" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.skills === null
                                        ? "Other"
                                        : _vm.skills.category
                                    )
                                  ),
                                ]),
                                _c("h4", { staticClass: "card-title" }, [
                                  _vm._v("Skills Required"),
                                ]),
                                _vm.skills !== null
                                  ? _c(
                                      "ul",
                                      _vm._l(
                                        _vm.skills.skills,
                                        function (skill, index) {
                                          return _c(
                                            "li",
                                            {
                                              key: index,
                                              staticClass: "card-description",
                                            },
                                            [_vm._v(_vm._s(skill.skillName))]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "md-collapse-pane-2" },
                        [
                          _c(
                            "md-card",
                            { staticClass: "bg-success" },
                            [
                              _c("md-card-content", [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "card-category card-category-social",
                                    staticStyle: { "text-align": "center" },
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-dungeon" }),
                                    _vm._v(" Job Requirements"),
                                  ]
                                ),
                                _c("h4", { staticClass: "card-title" }, [
                                  _vm._v("Minimum Level of Education"),
                                ]),
                                _c("p", { staticClass: "card-description" }, [
                                  _vm._v(_vm._s(_vm.job.education)),
                                ]),
                                _c("h4", { staticClass: "card-title" }, [
                                  _vm._v("Minimum Work Experience"),
                                ]),
                                _c("p", { staticClass: "card-description" }, [
                                  _vm._v(_vm._s(_vm.job.experience)),
                                ]),
                                _vm.job && _vm.job.citizenship
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "h4",
                                          { staticClass: "card-title" },
                                          [_vm._v("Required Citizenship")]
                                        ),
                                        _vm._l(
                                          _vm.job.citizenship,
                                          function (citizenship, index) {
                                            return _c(
                                              "p",
                                              {
                                                key: index,
                                                staticClass: "card-description",
                                              },
                                              [_vm._v(_vm._s(citizenship))]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "md-collapse-pane-3" },
                        [
                          _c(
                            "md-card",
                            { staticClass: "bg-success" },
                            [
                              _c("md-card-content", [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "card-category card-category-social centre",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-clipboard-list",
                                    }),
                                    _vm._v(" Job Information"),
                                  ]
                                ),
                                _c("h4", { staticClass: "card-title" }, [
                                  _vm._v("Location"),
                                ]),
                                _c("p", { staticClass: "card-description" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.micro === null
                                        ? "No Location"
                                        : _vm.micro.location
                                    )
                                  ),
                                ]),
                                _c("h4", { staticClass: "card-title" }, [
                                  _vm._v("Application Deadline"),
                                ]),
                                _c("p", { staticClass: "card-description" }, [
                                  _vm._v(_vm._s(_vm.job.applicationDeadline)),
                                ]),
                                _vm.job.jobType === "Once-off Project/Task"
                                  ? _c("h4", { staticClass: "card-title" }, [
                                      _vm._v("Estimated Duration"),
                                    ])
                                  : _c("h4", { staticClass: "card-title" }, [
                                      _vm._v("Working Days"),
                                    ]),
                                _vm.job.jobType === "Once-off Project/Task" &&
                                _vm.micro !== null
                                  ? _c(
                                      "p",
                                      { staticClass: "card-description" },
                                      [_vm._v(_vm._s(_vm.micro.duration))]
                                    )
                                  : _vm.micro !== null
                                  ? _c(
                                      "ul",
                                      _vm._l(
                                        _vm.micro.daysOfTheWeek,
                                        function (days) {
                                          return _c(
                                            "li",
                                            {
                                              key: days,
                                              staticClass: "card-description",
                                            },
                                            [_vm._v(_vm._s(days))]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                                _vm.job.jobType === "Internship" ||
                                _vm.job.jobType === "Part-time"
                                  ? _c("h4", { staticClass: "card-title" }, [
                                      _vm._v("Working Hours Per Week"),
                                    ])
                                  : _vm._e(),
                                _vm.job.jobType === "Internship" ||
                                _vm.job.jobType === "Part-time"
                                  ? _c(
                                      "p",
                                      { staticClass: "card-description" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.micro === null
                                                ? "No Description"
                                                : _vm.micro.workingHours
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "md-collapse-pane-4" },
                        [
                          _c(
                            "md-card",
                            { staticClass: "bg-success" },
                            [
                              _c("md-card-content", [
                                _vm.job.jobType === "Once-off Project/Task"
                                  ? _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "card-category card-category-social centre",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-wallet",
                                        }),
                                        _vm._v(" Budget"),
                                      ]
                                    )
                                  : _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "card-category card-category-social centre",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-wallet",
                                        }),
                                        _vm._v(" Salary"),
                                      ]
                                    ),
                                _vm.job.jobType === "Once-off Project/Task"
                                  ? _c("h4", { staticClass: "card-title" }, [
                                      _vm._v("Budget"),
                                    ])
                                  : _c("h4", { staticClass: "card-title" }, [
                                      _vm._v("Salary"),
                                    ]),
                                _c("p", { staticClass: "card-description" }, [
                                  _vm._v(_vm._s(_vm.formatBudget(_vm.micro))),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }